import { IMG } from "./site";

// Each product page config drives the generic ProductPage template
export const PRODUCTS = {
    "portail-aluminium": {
        slug: "portail-aluminium",
        category: "Portails",
        title: "Portail aluminium sur mesure",
        seoTitle: "Portail aluminium sur mesure | Pose autour de Genève",
        seoDescription: "Portail aluminium sur mesure : design contemporain, durable et sans entretien. Pose autour de Genève, Pays de Gex et Haute-Savoie par Portail du Léman.",
        intro: "Le portail aluminium est une solution idéale pour obtenir une entrée élégante, durable et facile d'entretien. Léger, solide et personnalisable, il s'adapte aussi bien aux maisons contemporaines qu'aux propriétés plus classiques.",
        image: IMG.gateAlu,
        keywords: ["portail aluminium Genève", "portail alu Pays de Gex", "portail aluminium Haute-Savoie", "portail moderne", "portail sans entretien", "portail design"],
        bullets: [
            { t: "Sans entretien", d: "L'aluminium ne rouille pas et conserve sa finition au fil des années." },
            { t: "Sur mesure", d: "Dimensions, couleurs, motifs et remplissage adaptés à votre entrée." },
            { t: "Design contemporain", d: "Lignes pleines, ajourées ou mixtes pour une intégration parfaite." },
            { t: "Motorisable", d: "Compatible avec toutes les motorisations modernes — coulissant ou battant." },
        ],
    },
    "portail-coulissant": {
        slug: "portail-coulissant",
        category: "Portails",
        title: "Portail coulissant pour entrée de propriété",
        seoTitle: "Portail coulissant sur mesure | Pose et motorisation",
        seoDescription: "Portail coulissant aluminium, motorisé ou autoportant. Solution idéale pour terrain en pente ou entrée étroite. Pose autour du Léman.",
        intro: "Le portail coulissant est la solution idéale lorsque le dégagement intérieur est limité ou que le terrain est en pente. Disponible avec rail au sol ou en version autoportante.",
        image: "https://customer-assets.emergentagent.com/job_leman-portails/artifacts/zt3xrlzj_portail.png",
        keywords: ["portail coulissant Genève", "portail coulissant motorisé", "portail autoportant", "rail au sol", "portail coulissant sur mesure"],
        bullets: [
            { t: "Aluminium ou acier", d: "Choix du matériau selon votre budget et l'esthétique recherchée." },
            { t: "Motorisé", d: "Confort d'ouverture par télécommande, digicode ou interphone." },
            { t: "Rail au sol ou autoportant", d: "Adapté aux entrées étroites ou aux terrains en pente." },
            { t: "Sécurité renforcée", d: "Cellules photoélectriques et fin de course intégrés." },
        ],
    },
    "portail-battant": {
        slug: "portail-battant",
        category: "Portails",
        title: "Portail battant classique ou contemporain",
        seoTitle: "Portail battant sur mesure | Installation autour de Genève",
        seoDescription: "Portail battant 1 ou 2 vantaux, manuel ou motorisé, ferronnerie d'art ou aluminium contemporain. Pose autour de Genève, Pays de Gex et Haute-Savoie.",
        intro: "Le portail battant reste le choix classique pour les entrées disposant de l'espace nécessaire au débattement. Il peut être manuel ou motorisé, en 1 ou 2 vantaux, en aluminium contemporain ou en ferronnerie d'art.",
        image: "https://customer-assets.emergentagent.com/job_leman-portails/artifacts/0zhwnphr_PORTAIL%20battant%20%282%29.png",
        keywords: ["portail battant Genève", "portail 2 vantaux", "portail battant motorisé", "portail fer forgé", "remplacement portail"],
        bullets: [
            { t: "1 ou 2 vantaux", d: "Configuration adaptée à la largeur de votre entrée." },
            { t: "Motorisation possible", d: "Bras articulés ou vérins, selon la configuration." },
            { t: "Ferronnerie d'art", d: "Motifs sur mesure, finitions cuivrées ou dorées pour un rendu premium." },
            { t: "Remplacement", d: "Pose sur piliers existants ou neufs." },
        ],
    },
    "clotures": {
        slug: "clotures",
        category: "Clôtures",
        title: "Clôtures pour sécuriser et valoriser votre propriété",
        seoTitle: "Clôtures sur mesure à Genève, Pays de Gex & Haute-Savoie",
        seoDescription: "Clôture aluminium, rigide, décorative ou occultante. Pose sur mesure autour de Genève et du bassin lémanique.",
        intro: "Une clôture ne sert pas uniquement à délimiter un terrain. Elle sécurise, protège l'intimité et donne du caractère à votre propriété. Portail du Léman propose des clôtures adaptées à votre environnement, avec une finition soignée et durable.",
        image: IMG.metalFence,
        keywords: ["clôture Genève", "clôture Pays de Gex", "clôture aluminium", "clôture rigide", "clôture sur mesure"],
        bullets: [
            { t: "Clôture aluminium", d: "Design moderne, sans entretien, finition thermolaquée." },
            { t: "Clôture rigide", d: "Panneaux soudés, ultra résistants, sécurisation efficace." },
            { t: "Clôture décorative", d: "Motifs ajourés, finitions premium pour valoriser l'entrée." },
            { t: "Clôture occultante", d: "Lames pleines pour préserver totalement l'intimité." },
        ],
    },
    "brise-vue": {
        slug: "brise-vue",
        category: "Brise-vue",
        title: "Brise-vue et solutions d'occultation sur mesure",
        seoTitle: "Brise-vue sur mesure | Claustra, occultation et panneaux design",
        seoDescription: "Brise-vue aluminium, claustra et panneaux occultants pour jardin, terrasse, balcon. Sur mesure autour du Léman.",
        intro: "Le brise-vue permet de préserver votre intimité tout en améliorant l'esthétique de vos extérieurs. Nous proposons des solutions sur mesure pour jardins, terrasses, balcons, entrées de propriété et espaces professionnels.",
        image: IMG.briseVue,
        keywords: ["brise-vue Genève", "brise-vue aluminium", "claustra extérieur", "panneau occultant", "brise-vue terrasse"],
        bullets: [
            { t: "Brise-vue aluminium", d: "Lames horizontales ou verticales, finitions élégantes." },
            { t: "Claustra design", d: "Motifs ajourés laser pour une signature visuelle forte." },
            { t: "Panneaux occultants", d: "Totalement opaques pour terrasses et patios." },
            { t: "Sur mesure", d: "Adapté à votre terrain, votre exposition et votre style." },
        ],
    },
    "motorisation-portail": {
        slug: "motorisation-portail",
        category: "Motorisation",
        title: "Motorisation de portail et contrôle d'accès",
        seoTitle: "Motorisation de portail | Coulissant, battant, digicode, interphone",
        seoDescription: "Motorisation portail coulissant ou battant, télécommandes, digicode, interphone, visiophone et contrôle d'accès. Pose et SAV autour du Léman.",
        intro: "Nous installons des motorisations adaptées à votre portail et à votre fréquence d'utilisation. Une motorisation bien choisie apporte confort, sécurité et durabilité à votre installation.",
        image: IMG.motor,
        keywords: ["motorisation portail", "moteur portail coulissant", "moteur portail battant", "digicode", "interphone", "contrôle d'accès"],
        bullets: [
            { t: "Portail coulissant", d: "Moteurs à crémaillère silencieux et durables." },
            { t: "Portail battant", d: "Bras articulés ou vérins, ouverture progressive." },
            { t: "Digicode & télécommandes", d: "Accès simple, multi-utilisateurs et codes temporaires." },
            { t: "Interphone & visiophone", d: "Filaire ou sans-fil, intégré à votre installation." },
        ],
    },
};

// /portails landing page (overview)
export const PORTAILS_OVERVIEW = {
    slug: "portails",
    title: "Portails sur mesure pour maisons, villas et entreprises",
    seoTitle: "Portails sur mesure à Genève, Pays de Gex & Haute-Savoie",
    seoDescription: "Portail aluminium, coulissant, battant ou motorisé. Fourniture et pose sur mesure autour de Genève, Pays de Gex et Haute-Savoie.",
    intro: "Nous réalisons la fourniture et la pose de portails sur mesure adaptés à votre entrée, à votre terrain et au style de votre propriété. Qu'il s'agisse d'un portail coulissant, battant, manuel ou motorisé, nous vous conseillons sur la meilleure solution technique et esthétique.",
    children: ["portail-aluminium", "portail-coulissant", "portail-battant", "motorisation-portail"],
};
